<template>
  <div>
    <lcontainer
      v-if="tenant.tenant_profile && tenant.tenant_profile.company_name"
      class="mb-4"
    >
      <div class="heading  py-4 px-8">
        <div class="page text-white">
          {{ tenant.tenant_profile.company_name }}
        </div>
        <span class="text-white">{{ tenant.role }}</span>
      </div>
    </lcontainer>

    <lcontainer>
      <div class="py-4 px-8">
        <page-header class="py-2">Update Notification Settings</page-header>
      </div>

      <div class="flex flex-wrap ">
        <div
          v-for="(permission, index) in permissions"
          :key="index"
          class="w-full lg:w-1/4 md:w-1/3 sm:w-1/2 sm:p-2 p-4 items-center form-row px-4"
        >
          <div class="my-4 cursor-pointer">
            <div class="rounded overflow-hidden my-min-height shadow-lg">
              <div class="px-6 py-4">
                <div class="program-main capitalize mb-2 tenant-main-color">
                  {{ permission.title }}
                </div>

                <div class="my-2">
                  <switches color="green" v-model="permission.active">
                  </switches>
                  <span class="ml-4 mb-2 pb-2 font-bold">{{
                    permission.active ? "Yes" : "No"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @click="update" class="py-4 px-8 flex flex-end w-full">
        <lms-blue-button>Update</lms-blue-button>
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Switches from "vue-switches";
export default {
  components: {
    LmsBlueButton: () => import("@/components/general/button"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    Switches,
  },
  data() {
    return {
      tenant: {},
      form: {},
      search: "",
      permissions: "",
    };
  },
  computed: {
    searchPermissions() {
      //console.log({ hhhh: this.tenant });
      if (!this.tenant || this.tenant.permissions.length < 1) return;
      return this.tenant.permissions.filter((permission) => {
        return permission.display_name
          .toLowerCase()
          .match(this.search.toLowerCase());
      });
    },
  },
  async created() {
    this.permissions = await this.fetchNotificationSettings();
    //console.log({ ddd: this.permissions });
  },
  methods: {
    ...mapActions(["fetchNotificationSettings", "updateNotificationSettings"]),
    async update() {
      let allowed = this.permissions
        .filter((select) => {
          return select.active;
        })
        .map((permisson) => {
          return permisson.id;
        });

      let res = await this.updateNotificationSettings({ settings: allowed });
      if (res == true || res.status == 200 || res.status == 201) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Permissions updated successfully",
        });
      } else {
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.program-main {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
}

.program-content {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
}

.form-row {
  .modal-title {
    font-size: 24px;
    color: color(lms-admin);
  }

  .modal-field {
    color: color(lms-admin);
    margin-right: 4rem;
  }
  .close {
    background-color: #c2454b;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    font-size: 12px;
    top: -17px;
    z-index: 2;
    right: 11px;
  }
  z-index: 1;
  // max-width: 500px;
}
</style>
